export default [
  {
    header: 'Governance',
  },
  {
    title: 'Decentralization',
    route: 'gov',
    icon: 'ServerIcon',
  },
  {
    title: 'Wallets',
    route: 'wallets',
    icon: 'UsersIcon',
  },
]
